import {
  ToggleBurstModeEnabledMutation,
  useToggleBurstModeEnabledMutation,
} from "@modules/site/settings/queries.generated"
import { useTriggerErrorAlert } from "@modules/ui/components/ErrorAlert"
import { MutationUpdaterFn } from "apollo-client"
import gql from "graphql-tag"
import { DataProxy } from "apollo-cache"
import { Site } from "@modules/graphql/types"

export function useToggleBurstBuilds(siteId: string) {
  const [
    toggleBurstBuildsMutation,
    { loading },
  ] = useToggleBurstModeEnabledMutation()
  const [setError, errorAlert] = useTriggerErrorAlert()

  const toggleBurstBuilds = () => {
    setError(null)
    return toggleBurstBuildsMutation({
      variables: {
        siteId,
      },
      update: updateBurstModeEnabledCache(siteId) as MutationUpdaterFn<
        ToggleBurstModeEnabledMutation
      >,
      optimisticResponse: {
        toggleBurstModeEnabled: {
          success: true,
          message: null,
          __typename: `MutationResult`,
        },
      },
    }).catch(err => setError(err))
  }

  return [toggleBurstBuilds, { loading, errorAlert }] as const
}

function updateBurstModeEnabledCache(siteId: string) {
  return (
    proxy: DataProxy,
    { data }: { data: ToggleBurstModeEnabledMutation }
  ) => {
    if (!data?.toggleBurstModeEnabled?.success) {
      return
    }
    const fragmentInfo = {
      id: `Site:${siteId}`,
      fragment: gql`
        fragment siteDetailsBurstModeFrag on Site {
          id
          burstModeEnabled
        }
      `,
    }

    const site: Site | null = proxy.readFragment(fragmentInfo)

    if (site) {
      site.burstModeEnabled = !site.burstModeEnabled
    }

    proxy.writeFragment({
      ...fragmentInfo,
      data: site,
    })
  }
}
